//import 'ol/ol.css';
import { Map, Feature } from 'ol';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { Photos } from '../Shared/Photos/Photos';
import { TROOrder } from './TROModels';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { ActivityListFilter, ActivityListRequestModel, ActivityListType } from '../Shared/Activity/Activity';;
import { TRO_AffectedPaths } from './TRO_AffectedPaths';
import { TRO_Highlights } from './TRO_Highlights';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';


// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2 = '#placeholder-for-legalmodals2',

    TROPanel = '#TROPanel',
    troRecordListContainer = '#troRecordListContainer',
    troRecordListCloseBtn = '#troRecordListCloseBtn',
    troSelectedView_Title = '#troSelectedView_Title',
    troSelectedView_TitleCount = '#troSelectedView_TitleCount',
    troRecordFilter = '#troRecordFilter',
    troRecordTable = '#troRecordTable',
    troRecordListPaging = '#troRecordListPaging',
    troRecordListShowingStartBtn = '#troRecordListShowingStartBtn',
    troRecordListShowingPrevBtn = '#troRecordListShowingPrevBtn',
    troRecordListShowingNextBtn = '#troRecordListShowingNextBtn',
    troRecordListShowingEndBtn = '#troRecordListShowingEndBtn',
    troRecordListPageAmount = '#troRecordListPageAmount',
    troRecordListShowing = '#troRecordListShowing',
    troRecordListPrintBtn = '#troRecordListPrintBtn',
    troRecordListEditBtn = '#troRecordListEditBtn',
    troRecordListDeleteBtn = '#troRecordListDeleteBtn',
    troRecordListSiteNoticeBtn = '#troRecordListSiteNoticeBtn',
    troRecordListSitePlanBtn = '#troRecordListSitePlanBtn',
    troRecordListQueryBtn = '#troRecordListQueryBtn',
    troRecordListAnnotateBtn = '#troRecordListAnnotateBtn',
    troEditModal = '#troEditModal',
    troActivityBtn = '#troActivityBtn',
    troEditCloseBtn = '#troEditCloseBtn',
    troEditForm = '#troEditForm',
    troEditCancelBtn = '#troEditCancelBtn',
    troEditSubmitBtn = '#troEditSubmitBtn',
    troEditDeleteBtn = '#troEditDeleteBtn',
    troCreateModal = '#troCreateModal',
    troCreateCloseBtn = '#troCreateCloseBtn',
    troCreateForm = '#troCreateForm',
    troCreateCancelBtn = '#troCreateCancelBtn',
    troCreateSubmitBtn = '#troCreateSubmitBtn',

    
}

export class TRO {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private currentPage: number = 0;
    private photos: Photos = new Photos();
    private TRO_AffectedPaths: TRO_AffectedPaths = new TRO_AffectedPaths();
    private TRO_Highlights: TRO_Highlights = new TRO_Highlights();
    private currentSortOrder;
    private currentSortDirection: OrderDirection;

    // List of buttions in the action toolbar
    private listActionBtns = {
        viewprint: { btn: $(jqc.troRecordListPrintBtn +' button'), enable: false },
        query: { btn: $(jqc.troRecordListQueryBtn + ' button'), enable: false },
        edit: { btn: $(jqc.troRecordListEditBtn + ' button'), enable: false },
        delete: { btn: $(jqc.troRecordListDeleteBtn + ' button'), enable: false },
        sitenotice: { btn: $(jqc.troRecordListSiteNoticeBtn + ' button'), enable: false },
        siteplan: { btn: $(jqc.troRecordListSitePlanBtn + ' button'), enable: false },
        annotate: { btn: $(jqc.troRecordListAnnotateBtn + ' button'), enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: Map) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // CLOSE BUTTONS
        Utilities.GetControl(jqc.troRecordListCloseBtn).on('click', function () {
            Utilities.GetControl(jqc.TROPanel).removeClass('show');
        });

        // CONSUlTATIONS FILTER
        Utilities.GetControl(jqc.troRecordFilter).on('change', function () { self.GetTROs(); });
        Utilities.GetControl(jqc.troRecordListPageAmount).on('change', function () {
            self.issueMaxNumberInList = $(jqc.troRecordListPageAmount+' select').children("option:selected").val() as number;
            self.GetTROs();
        });
        
        // CONSUlTATIONS PAGING BTNS
        Utilities.GetControl(jqc.troRecordListShowingStartBtn).on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetTROs();
        });
        Utilities.GetControl(jqc.troRecordListShowingEndBtn).on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetTROs();
        });
        Utilities.GetControl(jqc.troRecordListShowingNextBtn).on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur();
            self.GetTROs();
        });
        Utilities.GetControl(jqc.troRecordListShowingPrevBtn).on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetTROs();
        });

        // CONSUlTATION ACTION BUTTONS
        self.listActionBtns.viewprint.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            toastr.info("To be completed");
        });
        self.listActionBtns.query.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
        });
        self.listActionBtns.edit.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            self.openEditPanel(data);
        });
        self.listActionBtns.delete.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            self.deleteTRO(data);
        });
        self.listActionBtns.sitenotice.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            toastr.info("To be completed");
        });
        self.listActionBtns.siteplan.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            toastr.info("To be completed");
        });
        self.listActionBtns.annotate.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROCode, featureType: FeatureType.TRO };
            events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
        });
        
        // CONSULTATIONS TABLE
        // Initialize table
        var table: any = Utilities.GetControl(jqc.troRecordTable)
        if (table != null && table.bootstrapTable) {
            table.bootstrapTable();

            table.on('click-row.bs.table', function (e, row, $element) {
            });
            table.on('check.bs.table', function (e, row, $element) {
                self.checkListVisibleButtons();
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkListVisibleButtons();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkListVisibleButtons();
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkListVisibleButtons();
            });
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "AnnotationCount") {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, true, FeatureType.TRO]));
                }
            });
            table.on('sort.bs.table', function (e, name, order) {
                e.preventDefault();
                switch (name) {
                    case "TROCode":
                        self.currentSortOrder = TROOrder.TROCode;
                        break;
                    case "OrderTitle":
                        self.currentSortOrder = TROOrder.OrderTitle;
                        break;
                    case "StartDate":
                        self.currentSortOrder = TROOrder.StartDate;
                        break;
                    case "EndDate":
                        self.currentSortOrder = TROOrder.EndDate;
                        break;
                    default:
                        self.currentSortOrder = null;
                        break;
                }

                switch (order) {
                    case "asc":
                        self.currentSortDirection = OrderDirection.ASC;
                        break;
                    case "desc":
                        self.currentSortDirection = OrderDirection.DESC;
                        break;
                }

                self.GetTROs();
            });
        }

        // Add filters on the list panel
        let listFilters: Array<IFilterDefinitionModel> = Utilities.GetControl(jqc.troRecordListContainer + ' [data-listfilters]').data('listfilters');
        if (listFilters != null) {
            listFilters.forEach(f => {
                Utilities.GetControl(jqc.troRecordFilter).append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });
        }
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenListPanel = (): void => {
        const self = this;

        // rest page
        self.resetPage();

        // Show the page
        Utilities.GetControl(jqc.TROPanel).addClass('show');

        // Get data
        self.GetTROs();
    }

    public openCreatePanel = (): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/TRO/TROCreate', { }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.troCreateModal, ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader(jqc.troCreateModal);

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.troCreateModal));

            // IsPermenant
            $(jqc.troCreateForm + ' [name="IsPermanent"]').on('change', function () {
                if ($(this).is(":checked") == true) {
                    Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').prop('disabled', true);
                    Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').prop('readonly', true);
                    Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').val("");
                }
                else {
                    Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').prop('disabled', false);
                    Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').prop('readonly', false);
                }
            });
            if ($(jqc.troCreateForm + ' [name="IsPermanent"]').is(":checked") == true) {
                Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').prop('disabled', true);
                Utilities.GetControl(jqc.troCreateForm + ' [name="EndDate"]').prop('readonly', true);
            }

            // Submit
            Utilities.GetControl(jqc.troCreateSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.troCreateForm);
                if (form.validate().form() == false) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please make sure you have entered all required values.");
                    });
                    return;
                }

                doSubmit();
                function doSubmit() {
                    Utilities.BlockUI($(jqc.troCreateModal+ " .modal-content"));
                    let formData = new FormData(<any>Utilities.GetControl(jqc.troCreateForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/TRO/CreateTRO',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    Utilities.GetModal(jqc.troCreateModal, ModalAction.Hide);
                                    self.GetTROs();
                                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.TRO));

                                    self.TRO_Highlights.newTROWizard_Start(result.data.troCode, false);
                                }
                                else {
                                    if (result.message == null) toastr.error('Failed to edit TRO!');
                                    else toastr.error(result.message)
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($(jqc.troCreateModal + " .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            Utilities.GetControl(jqc.troCreateCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.troCreateModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.troCreateCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.troCreateModal, ModalAction.Hide);
            });
        });
    }

    public openEditPanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/TRO/TROEdit', { troCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.troEditModal, ModalAction.Create);

            Utilities.GetControl(jqc.troActivityBtn).on("click", function () {
                self.showActivityInPopover($(this), data, ActivityListType.TROActivity, Utilities.GetControl(jqc.troEditModal));
                this.blur();
            });

            //initialise photo uploader
            self.photos.setupUploader(jqc.troEditModal);

            // Initialize different sections
            self.TRO_AffectedPaths.initEvents(data);

            // Initialize different sections
            self.TRO_Highlights.initEvents(data);

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.troEditModal));

            // IsPermenant
            $(jqc.troEditForm + ' [name="IsPermanent"]').on('change', function () {
                if ($(this).is(":checked") == true) {
                    Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').prop('disabled', true);
                    Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').prop('readonly', true);
                    Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').val("");
                }
                else {
                    Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').prop('disabled', false);
                    Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').prop('readonly', false);
                }
            });
            if ($(jqc.troEditForm + ' [name="IsPermanent"]').is(":checked") == true) {
                Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').prop('disabled', true);
                Utilities.GetControl(jqc.troEditForm + ' [name="EndDate"]').prop('readonly', true);
            }

            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.troEditForm).serialize();

            // Submit
            Utilities.GetControl(jqc.troEditSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.troEditForm);
                if (form.validate().form() == false) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please make sure you have entered all required values.");
                    });
                    return;
                }

                doSubmit();
                function doSubmit() {
                    Utilities.BlockUI($(jqc.troEditModal + " .modal-content"));
                    let formData = new FormData(<any>Utilities.GetControl(jqc.troEditForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/TRO/UpdateTRO',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });


                                    Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
                                    self.GetTROs();
                                }
                                else {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    //if (result.message == null) toastr.error('Failed to edit TRO!');
                                    //else toastr.error(result.message)
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($(jqc.troEditModal + " .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            Utilities.GetControl(jqc.troEditCloseBtn).on('click', function (evt) {
                if (originalFormData != Utilities.GetControl(jqc.troEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
                    });
                }
                else Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.troEditCancelBtn).on('click', function (evt) {
                if (originalFormData != Utilities.GetControl(jqc.troEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
                    });
                }
                else Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.troEditDeleteBtn).on('click', function (evt) {
                self.deleteTRO(data, function (success) {
                    if (success == true) {
                        Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
                    }
                });
            });
        });
    }

    public openEditGeomPanel = (data: ICAMSKey): void => {
        this.TRO_Highlights.openEditGeomPanel(data);
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTROs = (): void => {
        const self = this;

        let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.troRecordFilter).children("option:selected").data('filterdefinition');
        
        let url = "/TRO/GetTROs";
        let query = { viewName: filterDef.viewName, Order: self.currentSortOrder, orderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList };

        Utilities.BlockUI(Utilities.GetControl(jqc.troRecordListContainer));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.troRecordTable)
                        table.bootstrapTable('load', data)
                        self.updatePagingUI();
                  
                        // Update count
                        var countStr = " (" + result.total + ")";
                        self.issueCountFromServer = result.total;
                        Utilities.GetControl(jqc.troSelectedView_TitleCount).html(countStr);
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.troRecordListContainer));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // CHECK BUTTONS
    private checkListVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.troRecordTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.listActionBtns).forEach(k => {
            self.listActionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        if (rows && rows.length == 1) {
            self.listActionBtns.viewprint.enable = true;
            self.listActionBtns.query.enable = true;
            self.listActionBtns.edit.enable = true;
            self.listActionBtns.delete.enable = true;
            self.listActionBtns.sitenotice.enable = true;
            self.listActionBtns.siteplan.enable = true;
            self.listActionBtns.annotate.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.listActionBtns).forEach(k => {
            if (self.listActionBtns[k].enable == true) self.listActionBtns[k].btn.prop("disabled", false);
            else self.listActionBtns[k].btn.prop("disabled", true);
        });
    }

    
    // ----------------------------------------------------------- //
    // DELETE
    public deleteTRO = (data: ICAMSKey, callback: Function = null): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/TRO/DeleteTRO', { troCode: data.code },
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.TRO));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            self.GetTROs();
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            if (callback != null) callback(true);
                        }
                        else {
                            if (result.message != null) toastr.error(result.message);
                            else toastr.error('Delete failed: the record has child records - delete these before deleting the parent record.');
                            if (callback != null) callback(false);
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                        if (callback != null) callback(false);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    public deleteTROGeom = (data: ICAMSKey): void => {
        this.TRO_Highlights.deleteTROGeom(data, true, null );
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { Utilities.GetControl(jqc.troSelectedView_TitleCount).html(' (' + self.issueCountFromServer + ')'); } else { Utilities.GetControl(jqc.troSelectedView_TitleCount).html(""); }
        Utilities.GetControl(jqc.troRecordListShowing).html((self.currentPage + 1).toString());

        self.checkListVisibleButtons();
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;

        this.updatePagingUI();
    }

    private showActivityInPopover = (el: JQuery<HTMLElement>, data: ICAMSKey, activityType: ActivityListType, parentModal: JQuery<HTMLElement>): void => {
        let model: ActivityListRequestModel = { ID: data.code, ActivityListType: activityType, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
        events.bus.publish(events.eventShowActivityList([el, model, parentModal]));
    }
}




